import { render } from "./ScannedValueInput.vue?vue&type=template&id=0901a4eb"
import script from "./ScannedValueInput.vue?vue&type=script&lang=ts"
export * from "./ScannedValueInput.vue?vue&type=script&lang=ts"
script.render = render

export default script